import { mount } from '@reveni-io/return-protection-widget'

export const replacePreview = (preview, target, config) => {
  const unmountPrevious = preview.unmount

  preview.unmount = mount(target, config)

  if (unmountPrevious) requestAnimationFrame(unmountPrevious)
}
